var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-100 vertical-space align-center",attrs:{"id":"no-results"}},[_c('div',{staticClass:"no-results"},[_c('h3',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_vm._t("extra_slot")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }